/* De Kievid — kerstboom van twinkelende lichtdeeltjes op <canvas class="dk-boom">.
   Kleuren komen uit data-attributen (instelbaar via de theme editor):
   data-kleuren="#D8A544|#F6F0E5|#C0452F" en data-gloed="216,165,68".
   Respecteert prefers-reduced-motion (statisch beeld). */
(function () {
  'use strict';

  function initBoom(canvas) {
    if (!canvas.getContext || canvas.dataset.dkBoomInit) return;
    canvas.dataset.dkBoomInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, raf = null;
    var lichtjes = [], vonken = [];
    var basis = (canvas.dataset.kleuren || '#D8A544|#F6F0E5|#C0452F').split('|');
    var KLEUREN = [basis[0], basis[0], basis[0], basis[1] || basis[0], basis[2] || basis[0]];
    var GLOED = canvas.dataset.gloed || '216,165,68';
    var boom = { cx: 0, voetY: 0, hoogte: 0, straal: 0 };

    function resize() {
      var r = canvas.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = Math.max(1, Math.round(w * dpr));
      canvas.height = Math.max(1, Math.round(h * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      boom.hoogte = Math.min(h * 0.72, 420);
      boom.voetY = h - Math.max(28, h * 0.1);
      boom.cx = w / 2;
      boom.straal = Math.min(boom.hoogte * 0.37, w * 0.4);
    }

    function maakVonk(init) {
      return {
        u: init ? Math.random() : 0.05 + Math.random() * 0.2,
        x: Math.random() * 2 - 1,
        snelheid: 0.05 + Math.random() * 0.05,
        maat: 0.8 + Math.random() * 1.1,
        fase: Math.random() * Math.PI * 2
      };
    }

    function vul() {
      lichtjes = [];
      var n = Math.round(Math.min(240, boom.hoogte * 0.55));
      for (var i = 0; i < n; i++) {
        lichtjes.push({
          u: Math.pow(Math.random(), 0.75),
          hoek: Math.random() * Math.PI * 2,
          tempo: 0.22 + Math.random() * 0.3,
          rJit: 0.8 + Math.random() * 0.28,
          maat: 1.1 + Math.random() * 1.7,
          fase: Math.random() * Math.PI * 2,
          kleur: KLEUREN[(Math.random() * KLEUREN.length) | 0]
        });
      }
      vonken = [];
      for (var j = 0; j < 10; j++) vonken.push(maakVonk(true));
    }

    function teken(t) {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';

      for (var i = 0; i < lichtjes.length; i++) {
        var p = lichtjes[i];
        var hoek = p.hoek + t * p.tempo;
        var diepte = (Math.sin(hoek) + 1) / 2;
        var R = boom.straal * (1 - p.u) * p.rJit;
        var x = boom.cx + Math.cos(hoek) * R;
        var y = boom.voetY - p.u * boom.hoogte + Math.sin(t * 1.4 + p.fase) * 2;
        var twinkel = 0.55 + 0.45 * Math.sin(t * 2.2 + p.fase);
        var a = (0.28 + 0.62 * diepte) * twinkel;
        var m = p.maat * (0.6 + 0.55 * diepte);
        ctx.fillStyle = p.kleur;
        ctx.globalAlpha = a * 0.28;
        ctx.beginPath(); ctx.arc(x, y, m * 3, 0, 6.2832); ctx.fill();
        ctx.globalAlpha = a;
        ctx.beginPath(); ctx.arc(x, y, m, 0, 6.2832); ctx.fill();
      }

      for (var k = 0; k < vonken.length; k++) {
        var v = vonken[k];
        v.u += v.snelheid * 0.016;
        if (v.u > 1.05) vonken[k] = v = maakVonk(false);
        var vr = boom.straal * Math.max(0, 1 - v.u) * 0.6;
        var vx = boom.cx + v.x * vr + Math.sin(t + v.fase) * 6;
        var vy = boom.voetY - v.u * (boom.hoogte + 30);
        var va = Math.max(0, Math.sin(Math.PI * Math.min(1, v.u)));
        ctx.globalAlpha = va * 0.7;
        ctx.fillStyle = KLEUREN[3];
        ctx.beginPath(); ctx.arc(vx, vy, v.maat, 0, 6.2832); ctx.fill();
      }

      var sx = boom.cx, sy = boom.voetY - boom.hoogte - 14;
      var puls = 0.85 + 0.15 * Math.sin(t * 1.8);
      var g = ctx.createRadialGradient(sx, sy, 0, sx, sy, 26 * puls);
      g.addColorStop(0, 'rgba(255, 246, 228, 0.95)');
      g.addColorStop(0.25, 'rgba(' + GLOED + ', 0.55)');
      g.addColorStop(1, 'rgba(' + GLOED + ', 0)');
      ctx.globalAlpha = 1;
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(sx, sy, 26 * puls, 0, 6.2832); ctx.fill();
      ctx.strokeStyle = 'rgba(255, 246, 228, 0.9)';
      ctx.lineWidth = 1.4;
      var lang = 15 * puls, kort = 7 * puls;
      ctx.beginPath();
      ctx.moveTo(sx - lang, sy); ctx.lineTo(sx + lang, sy);
      ctx.moveTo(sx, sy - lang); ctx.lineTo(sx, sy + lang);
      ctx.stroke();
      ctx.globalAlpha = 0.6;
      ctx.beginPath();
      ctx.moveTo(sx - kort, sy - kort); ctx.lineTo(sx + kort, sy + kort);
      ctx.moveTo(sx + kort, sy - kort); ctx.lineTo(sx - kort, sy + kort);
      ctx.stroke();

      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }

    var t0 = null;
    var inBeeld = true;
    function stap(ms) {
      if (t0 === null) t0 = ms;
      teken((ms - t0) / 1000);
      raf = requestAnimationFrame(stap);
    }

    function start() {
      if (reduce.matches || !inBeeld) return;
      resize();
      vul();
      t0 = null;
      if (!raf) raf = requestAnimationFrame(stap);
    }

    /* buiten beeld: alleen de lus stilzetten, het laatste frame blijft staan */
    function pauzeer() {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    }

    function stop() {
      pauzeer();
      resize();
      vul();
      teken(0);
    }

    reduce.matches ? stop() : start();
    reduce.addEventListener('change', function (e) { e.matches ? stop() : start(); });
    window.addEventListener('resize', function () {
      resize();
      if (!raf) { vul(); teken(0); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inBeeld = entries[entries.length - 1].isIntersecting;
        inBeeld ? start() : pauzeer();
      }, { rootMargin: '80px' }).observe(canvas);
    }
  }

  function initAlle() {
    document.querySelectorAll('canvas.dk-boom').forEach(initBoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlle);
  } else {
    initAlle();
  }

  /* Theme editor: sectie opnieuw geladen */
  document.addEventListener('shopify:section:load', initAlle);
})();
